import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    CREATED: {
        id: 'CardStatus.created',
        defaultMessage: 'Created',
    },
    NORMAL: {
        id: 'CardStatus.normal',
        defaultMessage: 'Normal',
    },
    BLOCKED: {
        id: 'CardStatus.blocked',
        defaultMessage: 'Blocked',
    },
    PENDING: {
        id: 'CardStatus.pending',
        defaultMessage: 'Pending',
    },
    LOST: {
        id: 'CardStatus.lost',
        defaultMessage: 'Lost',
    },
    ROBBED: {
        id: 'CardStatus.robbed',
        defaultMessage: 'Robbed',
    },
    EXPIRED: {
        id: 'CardStatus.expired',
        defaultMessage: 'Expired',
    },
    DAMAGED: {
        id: 'CardStatus.damaged',
        defaultMessage: 'Damaged',
    },
    FRAUD: {
        id: 'CardStatus.fraud',
        defaultMessage: 'Fraud',
    },
    WARNING: {
        id: 'CardStatus.warning',
        defaultMessage: 'Warning',
    },
    CANCELED: {
        id: 'CardStatus.canceled',
        defaultMessage: 'Canceled',
    },
    DELETED: {
        id: 'CardStatus.deleted',
        defaultMessage: 'Deleted',
    },
    THEFT: {
        id: 'CardStatus.theft',
        defaultMessage: 'Theft',
    },
    SHAVED: {
        id: 'CardStatus.shaved',
        defaultMessage: 'Shaved',
    },
    RENAME: {
        id: 'CardStatus.rename',
        defaultMessage: 'Rename',
    },
    RELIEF_LOSS: {
        id: 'CardStatus.relief_loss',
        defaultMessage: 'Relief Loss',
    },
    REISSUED: {
        id: 'CardStatus.reissued',
        defaultMessage: 'Reissued',
    },
    INOPERATIVE: {
        id: 'CardStatus.inoperative',
        defaultMessage: 'Inoperative',
    },
    INCORRECT_NAME: {
        id: 'CardStatus.incorrect_name',
        defaultMessage: 'Incorrect name',
    },
    DEFECT: {
        id: 'CardStatus.defect',
        defaultMessage: 'Defect',
    },
    CLIENT_ORDER: {
        id: 'CardStatus.client_order',
        defaultMessage: 'Client order',
    },
    BROKEN: {
        id: 'CardStatus.broken',
        defaultMessage: 'Broken',
    },
    UNBOUND: {
        id: 'CardStatus.unbound',
        defaultMessage: 'Unbound',
    },
    UNRECEIVED: {
        id: 'CardStatus.unreceived',
        defaultMessage: 'Unreceived',
    },
    VIRTUAL: {
        id: 'CardType.virtual',
        defaultMessage: 'Virtual',
    },
    PLASTIC: {
        id: 'CardType.plastic',
        defaultMessage: 'Plastic',
    },
});

export default enumMessages;
